(() => {
  const initialHash = window.afaInitialPageHash || window.location.hash;
  if (!initialHash) return;

  let targetId;
  try {
    targetId = decodeURIComponent(initialHash.slice(1));
  } catch (error) {
    targetId = initialHash.slice(1);
  }

  const target = document.getElementById(targetId);
  const main = document.getElementById('MainContent');
  if (!target || !main || !('ResizeObserver' in window)) {
    if (window.afaInitialPageHash) {
      const restoreFallbackHash = () => {
        window.history.replaceState(
          window.history.state,
          '',
          window.location.pathname + window.location.search + initialHash
        );
      };
      if (document.readyState === 'complete') restoreFallbackHash();
      else window.addEventListener('load', restoreFallbackHash, { once: true });
    }
    return;
  }

  const stableDelay = 1000;
  const maximumRunTime = 12000;
  const navigationKeys = new Set(['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' ']);
  let stableTimer;
  let stopTimer;
  let stopped = false;
  let pageLoaded = document.readyState === 'complete';

  const restoreHash = () => {
    if (!window.afaInitialPageHash) return;
    window.history.replaceState(
      window.history.state,
      '',
      window.location.pathname + window.location.search + initialHash
    );
    window.afaInitialPageHash = '';
  };

  const alignTarget = () => {
    if (stopped || !pageLoaded) return;

    const scrollMargin = Number.parseFloat(window.getComputedStyle(target).scrollMarginTop) || 0;
    const targetTop = target.getBoundingClientRect().top + window.scrollY - scrollMargin;

    if (Math.abs(window.scrollY - targetTop) < 2) {
      restoreHash();
      stop();
      return;
    }

    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    restoreHash();
    window.scrollTo({ top: targetTop, left: 0, behavior });
    stop();
  };

  const scheduleAlignment = () => {
    if (stopped || !pageLoaded) return;
    window.clearTimeout(stableTimer);
    stableTimer = window.setTimeout(alignTarget, stableDelay);
  };

  const observer = new ResizeObserver(scheduleAlignment);
  observer.observe(main);

  const stop = () => {
    if (stopped) return;
    stopped = true;
    restoreHash();
    observer.disconnect();
    window.clearTimeout(stableTimer);
    window.clearTimeout(stopTimer);
    window.removeEventListener('wheel', stop);
    window.removeEventListener('touchstart', stop);
    window.removeEventListener('pointerdown', stop);
    window.removeEventListener('keydown', stopOnNavigationKey);
  };

  const stopOnNavigationKey = (event) => {
    if (navigationKeys.has(event.key)) stop();
  };

  window.addEventListener('wheel', stop, { passive: true });
  window.addEventListener('touchstart', stop, { passive: true });
  window.addEventListener('pointerdown', stop, { passive: true });
  window.addEventListener('keydown', stopOnNavigationKey);

  const begin = () => {
    pageLoaded = true;
    scheduleAlignment();
    // If the page never becomes fully quiet, perform one final correction at
    // the time limit rather than leaving the visitor at the initial position.
    stopTimer = window.setTimeout(alignTarget, maximumRunTime);
  };

  if (pageLoaded) {
    begin();
  } else {
    window.addEventListener('load', begin, { once: true });
  }
})();
